<template>
    <div>
        <b-row>
            <b-col>
                <h5>Pay Periods</h5>
            </b-col>

            <b-col align="right">
                <b-button @click="openAddPayPeriod" variant="outline-secondary" size="sm" tabindex="-1">
                    <b-icon-plus></b-icon-plus>
                </b-button>
            </b-col>
        </b-row>

        <b-row v-for="range in ranges" :key="range._id">
            <b-col>
                <b-input-group size="sm">
                    <b-form-datepicker v-model="range.start" @input="updatePayPeriodStart(range)"></b-form-datepicker>
                    <b-form-datepicker v-model="range.end" @input="updatePayPeriodEnd(range)"></b-form-datepicker>

                    <b-input-group-append>
                        <b-button size="sm" variant="outline-info" @click="openSummary(range.start, range.end)">
                            <b-icon-clock-history></b-icon-clock-history>
                        </b-button>
                    </b-input-group-append>
                </b-input-group>
            </b-col>
        </b-row>

        <b-row class="mt-5">
                <b-col>
                    <b-button-toolbar>
                    <b-button-group>
                        <b-button @click="showPaidDay" variant="outline-secondary" size="sm">
                            <b-icon-plus></b-icon-plus>
                            <span class="ml-2 mr-1">Add Paid Day</span>
                        </b-button>
                    </b-button-group>
                    </b-button-toolbar>
                </b-col>
        </b-row>

        <b-modal id="addPaidDay"
                 title="Add Paid Day"
                 size="lg"
                 centered>

            <template #modal-footer="{  }">
                <b-button size="sm" class="mb-0" :disabled="!canAddPaidDay" @click="addPaidDay" variant="success">
                    <b-icon-check-square-fill></b-icon-check-square-fill>
                    <span class="p-xl-2 pl-2 pr-1">Add</span>
                </b-button>

                <b-button size="sm" class="mb-0" @click="cancelAddPaidDay" variant="secondary">
                    <b-icon-x-square-fill></b-icon-x-square-fill>
                    <span class="p-xl-2 pl-2 pr-1">Cancel</span>
                </b-button>
            </template>
            <b-row>
                <b-col>
                    <b-input v-model="paidDayReason" placeholder="Reason" size="sm" />
                    <b-checkbox-group v-model="paidDayEmployees" class="mt-3">
                        <b-checkbox v-for="employee in ptoEmployees" :key="employee._id" :value="employee.username">{{ employee.username }}
                        </b-checkbox>
                    </b-checkbox-group>
                </b-col>

                <b-col>
                    <b-form-datepicker v-model="paidDayDate" placeholder="Select paid day" size="sm"></b-form-datepicker>
                </b-col>
            </b-row>
        </b-modal>

        <b-modal id="payPeriodSummary"
                 hide-footer
                 :title="'Hours for ' + moment(summary.start).format('M/D/YYYY') + ' - ' + moment(summary.end).format('M/D/YYYY')"
                 centered>
            <b-table striped
                     small
                     :items="periodTotals"
                     :fields="summaryFields">
                    <template #cell(employee)="data">
                        <b-link @click="showTimecard(data.item.employee)" v-if="!data.item._rowVariant">{{ data.item.employee }}</b-link>
                        <span v-else>Total</span>
                    </template>
            </b-table>
        </b-modal>

        <b-modal id="addPayPeriod"
                 size="lg"
                 scrollable
                 hide-header-close
                 button-size="sm"
                 centered
                 @hide="cancelAdd()">
            <template #modal-footer="{  }">
                <b-button size="sm" class="mb-0" @click="addPayPeriod" variant="success">
                    <b-icon-check-square-fill></b-icon-check-square-fill>
                    <span class="p-xl-2 pl-2 pr-1">Save</span>
                </b-button>

                <b-button size="sm" class="mb-0" @click="cancelAdd" variant="secondary">
                    <b-icon-x-square-fill></b-icon-x-square-fill>
                    <span class="p-xl-2 pl-2 pr-1">Discard</span>
                </b-button>
            </template>

            <template #modal-header>
                <b-col>
                    <h5 class="mb-0 pt-2">Add Pay Period</h5>
                </b-col>
            </template>

            <b-alert :show="payPeriodErrorMsg.length" variant="danger">{{ payPeriodErrorMsg }}</b-alert>

            <b-row>
                <b-col>
                    <h5>Start</h5>
                    <b-calendar size="sm" placeholder="Start Date" id="fromDate" v-model="start" class="mb-2"></b-calendar>
                </b-col>

                <b-col>
                    <h5>End</h5>
                    <b-calendar size="sm" placeholder="End Date" id="toDate" v-model="end" class="mb-2"></b-calendar>
                </b-col>
            </b-row>
        </b-modal>

        <b-modal id="editTimecardModal"
             :title="timecardTitle(employee)"
             size="md"
             scrollable
             button-size="sm"
             hide-footer
             centered
             @hide="openSummary(summary.start, summary.end)"
             @close="openSummary(summary.start, summary.end)">
      <timecard :entries="entries" :paidTimeOff="paidTimeOff" @reloadTimecard="showTimecard(employee)" editable="1"></timecard>
      <!-- <timecard :entries="entries" @reloadTimecard="fetchTimecard()"></timecard> -->
    </b-modal>
    </div>
</template>

<script>
    import timecardApi from "@/api/timecard";
    import moment from "moment";
    import Timecard from "../../views/Timecard";
    import timecardMixin from "../../mixins/timecard";
    import utils from "../../mixins/utils";

    export default {
        name: "PayPeriod",
        mixins: [ timecardApi, timecardMixin, utils ],
        components: { Timecard },
        data() {
            return {
                ranges: [],
                fields: [
                    { key: 'start', label: 'Start', formatter: date => {
                            if (date) {
                                return moment(date).format('M/D/YYYY');
                            }

                            return '';
                        }
                    },
                    { key: 'end', label: 'End', formatter: date => {
                            if (date) {
                                return moment(date).format('M/D/YYYY');
                            }

                            return '';
                        } },
                ],
                summaryFields: [
                    { key: 'employee', label: 'Employee' },
                    { key: 'hours', label: 'Hours' },
                    { key: 'pto', label: 'PTO' },
                ],
                start: null,
                end: null,
                payPeriodErrorMsg: '',
                totals: {},
                summary: {
                    start: null,
                    end: null,
                },
                employee: null,
                ptoEmployees: [],
                paidDayEmployees: [],
                paidDayDate: null,
                paidDayReason: null,
            };
        },
        mounted() {
            this.getAllRanges();
        },
        methods: {
            async showPaidDay() {
                this.paidDayDate = null;
                this.paidDayReason = null;
                this.ptoEmployees = await this.getPaidTimeOffEmployees();
                this.$bvModal.show('addPaidDay');
            },
            async addPaidDay() {
                for (let i = 0; i < this.paidDayEmployees.length; i++) {
                    const payload = {
                        username: this.paidDayEmployees[i],
                        reason: this.paidDayReason,
                        date: this.paidDayDate,
                    };

                    await this.addEmployeePaidDay(payload);
                }

                console.log(this.paidDayEmployees, this.paidDayDate);
                this.showToast('Paid Day', 'Added successfully');
                this.$bvModal.hide('addPaidDay');
            },
            cancelAddPaidDay() {
                this.$bvModal.hide('addPaidDay');
            },
            async showTimecard(employee) {
                this.employee = employee;
                await this.fetchTimecardForPayPeriod(employee, this.summary.start, this.summary.end);
                
                this.$bvModal.show('editTimecardModal');
            },
            roundHours(hours) {
                let fraction = hours - Math.floor(hours);

                if (fraction <= .12) {
                    fraction = 0;
                } else if (fraction <= .37) {
                    fraction = .25;
                } else if (fraction <= .62) {
                    fraction = .5;
                } else if (fraction <= .87) {
                    fraction = .75
                } else {
                    fraction = 1;
                }

                return Math.floor(hours) + parseFloat(fraction);
            },
            async updatePayPeriodStart(range) {
                await this.updateRange(range._id, { start: range.start });
            },
            async updatePayPeriodEnd(range) {
                await this.updateRange(range._id, { end: range.end });
            },
            async openSummary(start, end) {
                this.summary.start = start;
                this.summary.end = end;

                this.totals = await this.getTotals(start, end);
                this.$bvModal.show('payPeriodSummary');
            },
            openAddPayPeriod() {
                this.$bvModal.show('addPayPeriod');
            },
            cancelAdd() {
                this.$bvModal.hide('addPayPeriod');
            },
            async addPayPeriod() {
                try {
                    await this.createRange(this.start, this.end);
                    await this.getAllRanges();

                    this.$bvModal.hide('addPayPeriod');
                } catch (err) {
                    this.payPeriodErrorMsg = err.message;
                }
            },
            async getAllRanges() {
                try {
                    this.ranges = await this.getRanges();
                } catch (err) {
                    this.$emit('errors', err.message);
                }
            },
        },
        computed: {
            summaryTotal() {
                let total = 0;

                for (let user in this.totals) {
                    total += parseFloat(this.totals[user].hours);
                }

                return this.roundHours(total);
            },
            ptoTotal() {
                let total = 0;

                for (let user in this.totals) {
                    total += parseInt(this.totals[user].paidTime.length * 8);
                }

                return this.roundHours(total);
            },
            periodTotals() {
                let totals = [];

                for (let user in this.totals) {
                    let hours = parseFloat(this.totals[user].hours);
                    let pto = parseInt(this.totals[user].paidTime.length * 8);

                    totals.push({ employee: user, hours: this.roundHours(hours), pto: pto });
                }


                totals.push({ employee: 'Total', hours: this.summaryTotal, pto: this.ptoTotal, _rowVariant: 'success' });

                return totals;
            },
            canAddPaidDay() {
                return this.paidDayReason && this.paidDayReason.length > 0 && this.paidDayEmployees && this.paidDayEmployees.length > 0 && this.paidDayDate && this.paidDayDate.length > 0;
            },
        },
    }
</script>

<style scoped>

</style>